<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" @click="$router.push('/accountancy')" style="cursor: pointer">Contabilidad</li>
        <li class="breadcrumb-item active" aria-current="page">Pagos vs Dispersiones</li>
      </ol>
    </nav>
    <div class="container-fluid">
      <div class="result-zone" style="margin-top:20px;">
        <div class="card">
          <div class="card-body">
            <table class="table table-hover">
              <thead>
              <th></th>
              <th class="header">Clientes</th>
              <th class="header">Inversionistas</th>
              <th class="header">Faltante / Pendiente a Inversionistas</th>
              </thead>
              <tbody>
              <tr style="cursor: pointer!important" v-for="renglon in data"
                  v-on:click="showModal('modalDetalle', renglon)">
                <td style="font-weight: bold !important;">{{ renglon.titulo }}</td>
                <td align="right">$ {{ formatPrice(renglon.clientes, 2) }}</td>
                <td align="right">$ {{ formatPrice(renglon.inversionistas, 2) }}</td>
                <td align="right">$ {{ formatPrice(renglon.faltante, 2) }}</td>
              </tr>
              <tr class="total" style="font-weight: bold !important;">
                <td style="font-weight: bold !important;">Totales</td>
                <td align="right">$ {{ formatPrice(suma_clientes, 2) }}</td>
                <td align="right">$ {{ formatPrice(suma_inversionistas, 2) }}</td>
                <td align="right">$ {{ formatPrice(suma_faltante, 2) }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!--MODAL DETALLE-->
    <div class="modal fade" ref="modalDetalle" tabindex="-1" role="dialog" aria-hidden="true"
         style="overflow-y: scroll;">
      <div class="modal-dialog modal-lg" role="document" style="max-width:1200px!important">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ modal_titulo }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    v-on:click="hideModal('modalDetalle')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="max-width: 1200px">
            <div class="row">
              <div class="col-md-12">
                <div class="result-zone" style="margin-top:20px;">
                  <div class="card">
                    <div class="card-body">
                      <table class="table table-hover">
                        <thead>
                        <th class="header">ID</th>
                        <th class="header">ID Proyecto</th>
                        <th class="header" style="text-align: left !important">Nombre</th>
                        <th class="header">Clientes</th>
                        <th class="header">Inversionistas</th>
                        <th class="header">Faltante / Pendiente a Inversionistas</th>
                        </thead>
                        <tbody>
                        <tr style="cursor: pointer" v-for="renglon in dataDetalle"
                            v-on:click="showModal('modalClientes', renglon)">
                          <td style="font-weight: bold !important;">{{ renglon.clienteID }}</td>
                          <td style="font-weight: bold !important;text-align: center">{{ renglon.projectID }}</td>
                          <td style="font-weight: bold !important;">{{ renglon.cliente }}</td>
                          <td align="right">$ {{ formatPrice(renglon.clientes, 2) }}</td>
                          <td align="right">$ {{ formatPrice(renglon.inversionistas, 2) }}</td>
                          <td align="right">$ {{ formatPrice(renglon.faltante, 2) }}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--FIN MODAL DETALLE-->
    <!--MODAL CLIENTES-->
    <div class="modal hide fade" ref="modalClientes" tabindex="-1" role="dialog" aria-hidden="true"
         style="overflow-y: scroll;">
      <div class="modal-dialog modal-lg" role="document" style="max-width:1400px!important">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Cargos de {{ client_name }}</h5>
            <button type="button" class="close" v-on:click="hideModal('modalClientes')" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="card">
                  <div class="card-body">
                    <table class="table table-hover">
                      <thead>
                      <th class="header" style="text-align: left !important">Fecha</th>
                      <th class="header" style="text-align: left !important">No. Autorización</th>
                      <th class="header" style="text-align: left !important">Descripción</th>
                      <th class="header">Método</th>
                      <th class="header">Monto</th>
                      </thead>
                      <tbody>
                      <tr v-for="renglon in dataCliente">
                        <td style="font-weight: bold !important;">{{ renglon.creation_date }}</td>
                        <td style="font-weight: bold !important;">{{ renglon.authorization }}</td>
                        <td style="font-weight: bold !important;">{{ renglon.description }}</td>
                        <td> {{ renglon.method }}</td>
                        <td align="right">$ {{ formatPrice(renglon.amount, 2) }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--FIN MODAL CLIENTES-->
  </div>
</template>

<script>
import {Currency} from "@/models/Security/Currency";

export default {
  name: 'cobranza-pagos',
  props: [],
  mounted() {
    axios.get('/api/cobranza-pagos')
      .then((resolve) => {
        this.data = resolve.data.data;
        this.suma_clientes = resolve.data.suma_clientes;
        this.suma_inversionistas = resolve.data.suma_inversionistas;
        this.suma_faltante = resolve.data.suma_faltante;
      });
  },
  data() {
    return {
      data: [],
      dataDetalle: [],
      dataCliente: [],
      suma_clientes: 0,
      suma_inversionistas: 0,
      suma_faltante: 0,
      c_trxtype: 0,
      i_trxtype: 0,
      modal_titulo: '',
      client_name: '',
      customerid: '',
      project_id: 0
    }
  },
  watch: {
    c_trxtype: function () {
      if (this.c_trxtype != 0) {
        this.dataDetalle = [];
        switch (this.c_trxtype) {
          case 'C230':
            this.modal_titulo = 'Amortización';
            break;
          case 'C131':
            this.modal_titulo = 'Amortización anticipada';
            break;
          case 'C220':
            this.modal_titulo = 'Intereses';
            break;
          case 'C221':
            this.modal_titulo = 'Intereses moratorios';
            break;
          case 'C122':
            this.modal_titulo = 'Intereses amortización anticipada';
            break;
          case 'C240':
            this.modal_titulo = 'Penalizaciones';
            break;
          case 'C290':
            this.modal_titulo = 'IVA Intereses';
            break;
          case 'C291':
            this.modal_titulo = 'IVA Intereses moratorios';
            break;
          case 'C194':
            this.modal_titulo = 'IVA Intereses amortización anticipada';
            break;
          case 'C293':
            this.modal_titulo = 'IVA Penalizaciones';
            break;
        }
        ;
        axios.post('/api/cobranza-pagos/detalle', {
          c_trxtype: this.c_trxtype,
          i_trxtype: this.i_trxtype,
        })
          .then((resolve) => {
            this.dataDetalle = resolve.data.data;
          });
      }
    },
    customerid: function () {
      if (this.customerid != '') {
        axios.post('/api/cobranza-pagos/cliente', {
          customerid: this.customerid
        })
          .then((resolve) => {
            this.dataCliente = resolve.data.data;
          });
      }
    }
  },
  methods: {
    showModal(destino, renglon) {
      if (destino == "modalDetalle") {
        this.c_trxtype = renglon.c_trxtype;
        this.i_trxtype = renglon.i_trxtype;
        let element = this.$refs.modalDetalle;
        $(element).modal('show');
      }
      if (destino == "modalClientes") {
        let element2 = this.$refs.modalDetalle;
        $(element2).modal('hide');
        this.client_name = renglon.cliente;
        this.customerid = renglon.customerid;
        let element = this.$refs.modalClientes;
        $(element).modal('show');
      }
    },
    hideModal(destino) {
      if (destino == "modalDetalle") {
        this.dataDetalle = [];
        this.c_trxtype = 0;
        let element = this.$refs.modalDetalle;
        $(element).modal('hide');
      }
      if (destino == "modalClientes") {
        this.dataCliente = [];
        this.customerid = '';
        let element = this.$refs.modalClientes;
        $(element).modal('hide');
        let element2 = this.$refs.modalDetalle;
        $(element2).modal('show');
      }
    },
    formatPrice(value, decimales = 0) {
      let val = (value / 1).toFixed(decimales).replace(',', '.')
      return Currency.format(parseFloat(val))
    },
    algoritmo() {
      if (this.project_id != 0) {
        var checar = confirm("¿Esta seguro de divir los Client Payments con trx_type C110 en los 5 correspondientes, para el proyecto con ID " + this.project_id + "?");
        if (checar == true) {
          axios.post('/api/cobranza-pagos/algoritmo', {
            project_id: this.project_id
          }).then((resolve) => {
            swal("Algoritmo aplicado!", "Recargando datos...", "success");
            this.data = [];
            this.suma_clientes = 0;
            this.suma_inversionistas = 0;
            this.suma_faltante = 0;
            this.dataDetalle = [];
            this.dataCliente = [];
            axios.get('/api/cobranza-pagos')
              .then((resolve) => {
                this.data = resolve.data.data;
                this.suma_clientes = resolve.data.suma_clientes;
                this.suma_inversionistas = resolve.data.suma_inversionistas;
                this.suma_faltante = resolve.data.suma_faltante;
              });
          });
        }
      }
    },
    algoritmoC260() {
      if (this.project_id != 0) {
        var checar = confirm("¿Esta seguro de cambiar en los Client Payments con misma referencia, el status de 0 a 1 donde el trx_type C260 tenga status 1 para al proyecto con ID " + this.project_id + "?");
        if (checar == true) {
          axios.post('/api/cobranza-pagos/algoritmoC260', {
            project_id: this.project_id
          }).then((resolve) => {
            swal("Algoritmo aplicado!", "Recargando datos...", "success");
            this.data = [];
            this.suma_clientes = 0;
            this.suma_inversionistas = 0;
            this.suma_faltante = 0;
            this.dataDetalle = [];
            this.dataCliente = [];
            axios.get('/api/cobranza-pagos')
              .then((resolve) => {
                this.data = resolve.data.data;
                this.suma_clientes = resolve.data.suma_clientes;
                this.suma_inversionistas = resolve.data.suma_inversionistas;
                this.suma_faltante = resolve.data.suma_faltante;
              });
          });
        }
      }
    },
    algoritmoC2w60ForAllProjects() {
      // if(this.project_id != 0){
      var checar = confirm("¿Esta seguro de cambiar en los Client Payments con misma referencia, el status de 0 a 1 donde el trx_type C260 tenga status 1 \n\n  **********PARA TODOS LOS PROYECTOS?**********");
      if (checar == true) {
        axios.get('/api/cobranza-pagos/algoritmoC260ForAllProjects')
          .then((resolve) => {
            swal("Algoritmo aplicado!", "Recargando datos...", "success");
            this.data = [];
            this.suma_clientes = 0;
            this.suma_inversionistas = 0;
            this.suma_faltante = 0;
            this.dataDetalle = [];
            this.dataCliente = [];
            axios.get('/api/cobranza-pagos')
              .then((resolve) => {
                this.data = resolve.data.data;
                this.suma_clientes = resolve.data.suma_clientes;
                this.suma_inversionistas = resolve.data.suma_inversionistas;
                this.suma_faltante = resolve.data.suma_faltante;
              });
          });
      }
      // }
    }
  },
}
</script>
